"use strict";

var _interopRequireDefault = require("/data/www/prod-cn-snote-manage/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getModellist = getModellist;
var _request = _interopRequireDefault(require("@/utils/request"));
//设备更新报表
function getModellist(data) {
  return (0, _request.default)({
    url: 'equipment/counts/query',
    method: 'post',
    headers: {
      "Content-Type": 'application/json',
      "x-access-token": window.localStorage.getItem('token')
    },
    data: data
  });
}